import {
  AskUserQuestionChrome,
  UserQuestionAnswerBubble as SharedUserQuestionAnswerBubble,
  appendDocumentMentionsForAmbiguousManuscriptQuestions,
  feedbackTypePluginNamesFromMultiSelectAnswer,
  formatUserQuestionAnswerBlock,
  questionIsFeedbackTypesPicker,
  QUESTION_FEEDBACK_TYPES_PREFIX,
  USER_QUESTION_NO_PREFERENCE,
  type AppendedDocumentMentionsResult,
  type QuestionOption,
  type QuestionStep,
  type UserQuestionAnswerPair,
} from "@sudowrite/shared-chat";
import { Text } from "src/sudokit/components/Text";
import { cn } from "src/lib/cn";
import { stripTrailingDocumentMentionsFromDisplay } from "./mentions/mentionFormatUtils";
import { MentionMarkdown } from "./mentions/MentionMarkdown";

export type { UserQuestionAnswerPair, AppendedDocumentMentionsResult, QuestionOption, QuestionStep };

export {
  QUESTION_FEEDBACK_TYPES_PREFIX,
  USER_QUESTION_NO_PREFERENCE,
  feedbackTypePluginNamesFromMultiSelectAnswer,
  questionIsFeedbackTypesPicker,
  formatUserQuestionAnswerBlock,
  appendDocumentMentionsForAmbiguousManuscriptQuestions,
};

/** Matches `PersistentChatMessage` user bubble so Q/A reads as the user's reply. */
export function UserQuestionAnswerBubble({
  text,
  className,
  stripAppendedDocumentMentions = false,
}: {
  text: string;
  className?: string;
  stripAppendedDocumentMentions?: boolean;
}) {
  const visible = stripTrailingDocumentMentionsFromDisplay(text, stripAppendedDocumentMentions);
  return (
    <div className={cn(className)}>
      <SharedUserQuestionAnswerBubble>
        <Text as="div" className="min-w-0 break-words text-left leading-6">
          <MentionMarkdown text={visible} />
        </Text>
      </SharedUserQuestionAnswerBubble>
    </div>
  );
}

interface AskUserQuestionProps {
  questions: QuestionStep[];
  onSubmit: (pairs: UserQuestionAnswerPair[]) => void;
  onSkip: (pairs: UserQuestionAnswerPair[]) => void;
  disabled?: boolean;
  variant?: "default" | "bottomSheet";
}

export function AskUserQuestion({
  questions,
  onSubmit,
  onSkip,
  disabled,
  variant = "default",
}: AskUserQuestionProps) {
  return (
    <AskUserQuestionChrome
      questions={questions}
      onSubmit={onSubmit}
      onSkip={onSkip}
      disabled={disabled}
      presentation={variant === "bottomSheet" ? "bottomSheet" : "default"}
      renderQuestionTitle={(question, isFeedbackTypesPicker) =>
        isFeedbackTypesPicker ? (
          <Text as="div" className="min-w-0">
            <MentionMarkdown text={question} />
          </Text>
        ) : (
          question
        )}
      renderCompletedAnswer={(summaryText) => (
        <UserQuestionAnswerBubble text={summaryText} />
      )}
    />
  );
}
